import { H3 } from "@/shared/components/typography";
import t from "@/lang/lang";
import { useState } from "react";
import { ListRequest } from "@/services/backend/customers/api/service-object-api";
import {
  ServiceObjectsTable,
  ServiceObjectsTableFilters,
} from "@/services/backend/customers/components/service-objects-table";
import { CreateServiceObjectDialog } from "@/services/backend/customers/components/create-service-object-dialog";
import { NavLink, useParams } from "react-router";
import { NullUUID } from "@/shared/lib/utilities/uuid";
import {
  CustomerPageMain,
  CustomerPageMainContent,
  CustomerPageMainHeader,
} from "@/routes/customers/[customerId]/_components/customer-page";
import { CustomerPageBreadcrumbs } from "@/routes/customers/[customerId]/_components/customer-page-breadcrumbs";

export function ServiceObjectsRoute() {
  const { customerId } = useParams();
  const [request, setRequest] = useState<ListRequest>({
    customer: {
      active: true,
      values: [customerId ?? NullUUID],
    },
    limit: 10,
  });

  return (
    <CustomerPageMain>
      <CustomerPageMainHeader>
        <CustomerPageBreadcrumbs
          breadcrumbs={[
            {
              to: `/customers/${customerId}/service-objects`,
              label: t("Service Objekte"),
            },
          ]}
        />
      </CustomerPageMainHeader>
      <CustomerPageMainContent>
        <H3>{t("Service Objekte")}</H3>
        <div className="text-muted-foreground text-sm">
          {t(
            "Service Objekte sind Gebäude / Kantinen / Geräte / ... je nachdem was als Objekt festgelegt wird. Für ein Service Objekte wird ein Kunde Angebote anfordern. Ein Service Objekt ist auch regelmäßig das worüber ein Vertrag abgeschlossen wird, wobei auch mehrere Objekte in einem Vertrag sein können. Typischer Weise wird ein Service Objekt auch mit einem Arbeitsschein erledigt.",
          )}
        </div>
        <div className="mt-4 grid gap-2">
          <div className="flex items-center justify-between">
            <ServiceObjectsTableFilters
              request={request}
              onRequestChange={setRequest}
              hideCustomer
            />
            <CreateServiceObjectDialog customerId={customerId} />
          </div>
          <ServiceObjectsTable
            request={request}
            onRequestChange={setRequest}
            renderRowLink={(cid, soid, children) => (
              <NavLink to={`/customers/${cid}/service-objects/${soid}`}>
                {children}
              </NavLink>
            )}
          />
        </div>
      </CustomerPageMainContent>
    </CustomerPageMain>
  );
}
